// extracted by mini-css-extract-plugin
module.exports = {"firstFold":"firstFold_firstFold__qRa8F","heading":"firstFold_heading__He8Kp","subParagraph":"firstFold_subParagraph__GreCn"};